@layer module {
:global(.custom-toaster) {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
    }

:global(.custom-toaster .icon) {
            display: flex;
            flex-shrink: 0;
    }

:global(.custom-toaster .content) {
            flex: 1;
            min-width: 0;
            overflow-wrap: anywhere;
    }

:global(.custom-toaster .content > div) {
            margin: 0;
            justify-content: flex-start;
    }

:global(.custom-toaster .close-button) {
            display: grid;
            flex-shrink: 0;
            place-items: center;
            padding: 0;
            border: 0;
            border-radius: 50%;
            cursor: pointer;
    }
} // layer module










@layer app {
:global(.custom-toaster) {
            gap: $size-12;
    }

:global(.custom-toaster .close-button) {
            width: $size-24;
            height: $size-24;
    }

.custom-toaster-container {
            --toast-container-top: #{$size-100};
            --toast-container-z-index: 10010;
            --toast-display: block;
            --toast-radius: #{$size-10};
            --toast-font-size: var(--font-size-base);
            --toast-line-height: #{$size-17};
            --toast-font-style: normal;
            --toast-padding: #{$size-12} #{$size-14} #{$size-12} #{$size-16};
            --toast-width: max-content;
            --toast-max-width: min(#{$size-600}, calc(100vw - #{$size-32}));
            --toast-bg: var(--toaster-neutral-bg);
            --toast-text: var(--color-on-brand);
            --toast-shadow: var(--shadow-control);
            --toast-icon-success: var(--color-success);
            --toast-icon-error: var(--color-error);
            --toast-icon-glyph: var(--color-on-brand);
    }

:global(.custom-toaster .close-button) {
            background: transparent;
            color: var(--toast-text);
    }

.close-button:hover {
            opacity: 0.7;
    }

.close-button:focus-visible {
            outline: 2px solid var(--toast-text);
            outline-offset: 2px;
    }

      @media (max-width: 1150px) {
                .custom-toaster-container {
                        --toast-container-top: #{$size-7};
                    }
          }
} // layer app
